import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../../utils/api';

// Home's calm "Today" card: a glanceable summary of what's logged so far,
// tapping through to the full log. Home stays a cockpit; the detail lives in
// entries (nested under Data). Deliberately compact — not the 7-card grid.

const Stat = ({ label, value, unit }) => (
  <div>
    <p className="text-sm font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-300">{label}</p>
    <p className="mt-0.5 text-lg font-bold text-gray-900 dark:text-white tabular-nums">
      {value != null ? (
        <>{value}{unit && <span className="ml-0.5 text-sm font-normal text-gray-600 dark:text-gray-300">{unit}</span>}</>
      ) : (
        <span className="text-gray-600 dark:text-gray-300">—</span>
      )}
    </p>
  </div>
);

const TodayCard = () => {
  const [health, setHealth] = useState(null);
  const [fitbit, setFitbit] = useState(null);

  const today = new Date().toISOString().split('T')[0];

  const load = useCallback(async () => {
    const [h, f] = await Promise.allSettled([
      apiClient.get('/api/health/entries/summary', { params: { target_date: today } }),
      apiClient.get('/api/fitbit/summary'),
    ]);
    if (h.status === 'fulfilled') setHealth(h.value.data);
    if (f.status === 'fulfilled') setFitbit(f.value.data);
  }, [today]);

  useEffect(() => { load(); }, [load]);

  const caloriesIn = health?.total_calories_consumed;
  const steps = fitbit?.activity?.steps;
  const sleepMin = fitbit?.sleep?.total_minutes_asleep;
  const hydrationMl = health?.total_hydration_ml;

  return (
    <Link
      to="/log"
      className="card-glow block rounded-2xl border border-surface-border dark:border-surface-dark-border bg-surface-card dark:bg-surface-dark-card p-5 transition-shadow hover:shadow-card"
    >
      <div className="flex items-center justify-between gap-3 mb-4">
        <div>
          <h2 className="text-lg font-bold text-gray-900 dark:text-white">Today</h2>
          <p className="text-sm text-stone-600 dark:text-stone-300">What you've logged so far</p>
        </div>
        <span className="shrink-0 text-sm font-semibold text-primary-700 dark:text-primary-400">See log →</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <Stat label="Calories in" value={caloriesIn ? Math.round(caloriesIn) : null} unit="kcal" />
        <Stat label="Steps" value={steps ? steps.toLocaleString() : null} />
        <Stat label="Sleep" value={sleepMin ? (sleepMin / 60).toFixed(1) : null} unit="hrs" />
        <Stat label="Hydration" value={hydrationMl ? Math.round(hydrationMl) : null} unit="ml" />
      </div>
    </Link>
  );
};

export default TodayCard;
